import { render, staticRenderFns } from "./StcvPD_TotalRaw.vue?vue&type=template&id=42c52d1a"
import script from "./StcvPD_TotalRaw.vue?vue&type=script&lang=js"
export * from "./StcvPD_TotalRaw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports